<template>
  <div class="body">
    <form class="phone-container" action="" enctype="multipart/form-data">
      <input class="input-area phone" :class="iphoneIs?'editPadding':''" placeholder="请输入您的手机号码" type="number" autocomplete="off" v-model="phoneNumber" oninput="if(value.length>11)value=value.slice(0,11)">
      <input class="input-area code" :class="iphoneIs?'editPadding':''" id="codeInput" placeholder="请输入验证码" type="number" autocomplete="off" v-show="showCode" v-model="code" oninput="if(value.length>6)value=value.slice(0,6)">
      <div v-if="buttonClicked">
        <span v-if="count === 0" class="getCode-area" @click="getCodeToRegister(false)">重新获取</span>
        <span v-else class="countdown-area">{{ count }}s后重发</span>
      </div>
      <div class="getAccount" v-debounce="getCodeToRegister">免费领取额度</div>
      <div class="tips">
        <input class="haveReadAndAgree" v-model="readAndAgreeValue" type="checkbox"/>
          <span :class="readAndAgreeValue?'highlighted':'putTheash'">已阅读并同意</span><a target="_blank" href="https://api-m.haohuan.com/api/staticProtocol/getContentById?code=register_service" class="openProtocal">《注册服务协议》</a><a target="_blank" href="https://api-m.haohuan.com/api/staticProtocol/getContentById?code=privacy" class="openPrivacyProtocal">《隐私政策协议》</a>
      </div>
    </form>
    <div class="dialog-outer" v-show="showAlreadyRegister">
      <div class="content">
        <p class="text">您已是好分期用户</p>
        <p class="text-two">下载APP即可借款</p>
        <p class="dialog-btn download-btn" @click="download(true)">下载APP</p>
      </div>
    </div>
    <div class="dialog-outer" v-show="showRegisterSuccess">
      <div class="content">
        <p class="success-outer">
          <img src="../../../assets/img/indexNew/success.png" class="success-img">
        </p>
        <p class="text">注册成功</p>
        <p class="dialog-btn download-btn" @click="download(true)">下载APP</p>
      </div>
    </div>
    <div class="dialog-outer" v-show="showPictureCode">
      <div class="content content-code">
        <img src="../../../assets/img/indexNew/close.png" class="dialog-close" @click="handleClose('showPictureCode')">
        <p class="dialog-title">图片验证码</p>
        <p class="img-code-outer">
          <input class="img-code" placeholder="请输入验证码" type="text" maxlength="6" autocomplete="off" v-model="imgCode" />
          <img class="get-img-code" :src="codeSrc" alt="图片" border="0" @click="getImgCode">
        </p>
        <p class="dialog-btn check-img-btn" @click="actualVerifyImgCode">确定</p>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
@import "@/scss/base.scss";

@font-face {
  font-family: "DINPro-Regular";
  src: url("../../../assets/fonts/DINPro-Regular.ttf");
  font-weight: normal;
  font-style: normal;
}

.body {
  width: 100%;
  position: relative;
  overflow: hidden;
  background: url('../../../assets/img/indexNew/banner.jpg') no-repeat;
  background-size: 100%;
  img {
    width: 100%;
  }
  .btn {
    color: rgba(0, 0, 0, 0);
    background: rgba(55, 55, 55, 0);
    position: absolute;
    width: (146vw / $w);
    height: (40vw / $w);
    line-height: (40vw / $w);
    top: (270vw / $w);
    left: (25vw / $w);
    text-align: center;
  }
  .phone-container {
    width: (345vw / $w);
    margin-top: (198vw / $w);
    margin-left: (15vw / $w);
    padding: (23vw / $w)  (22.5vw / $w) (23.5vw / $w);
    background: #fff;
    border-radius: (7vw / $w);
    position: relative;
  }
  .input-area {
    display: inline-block;
    width: 100%;
    height: (45vw / $w);
    box-sizing: border-box;
    // line-height: normal;
    border-radius: (23vw / $w);
    text-indent: (18vw / $w);
    border: 1px solid #C1C1C1;
    margin-bottom: (18vw / $w);
    font-size: (17vw / $w);
    // font-family: DINPro-Regular,DINPro;
    font-family: "DINPro-Regular";
    color: #333;
    padding: (7vw / $w) 0 (10vw / $w) 0;
    caret-color: #FF3A3A;
  }
  .editPadding {
    padding: (15vw / $w) 0;
  }
  input::-webkit-input-placeholder {
    color: #CCCCCC;
    font-size: (14vw / $w);
    font-family:PingFangSC-Regular,PingFang SC;
    padding-top: (2vw / $w);
  }
  input::-moz-placeholder{   /* Mozilla Firefox 19+ */
    color: #CCCCCC;
    font-size: (14vw / $w);
    font-family:PingFangSC-Regular,PingFang SC;
    padding-top: (2vw / $w);
  }
  input:-moz-placeholder{    /* Mozilla Firefox 4 to 18 */
    color: #CCCCCC;
    font-size: (14vw / $w);
    font-family:PingFangSC-Regular,PingFang SC;
    padding-top: (2vw / $w);
  }
  input:-ms-input-placeholder{  /* Internet Explorer 10-11 */
    color: #CCCCCC;
    font-size: (14vw / $w);
    font-family:PingFangSC-Regular,PingFang SC;
    padding-top: (2vw / $w);
  }
  .countdown-area {
    position: absolute;
    right: (43vw / $w);
    top: (38vw / $w);
    color: #CCCCCC;
    font-size: (14vw / $w);
    line-height: (16vw / $w);
  }
  .getCode-area {
    position: absolute;
    right: (56vw / $w);
    top: (38vw / $w);
    color: #F44336;
    font-size: (14vw / $w);
    line-height: (16vw / $w);
  }
  .getAccount {
    width: 100%;
    height: (45vw / $w);
    border-radius: (23vw / $w);
    background: #FF3A3A;
    color: #fff;
    text-align: center;
    font-size: (17vw / $w);
    font-family:PingFangSC-Regular,PingFang SC;
    line-height: (45vw / $w);
  }
  .tips {
    margin-top: (16vw / $w);
    font-size: (11vw / $w);
    white-space: nowrap;
    text-align: center;
    color: #919199;
    opacity: 0.6;
    a {
      color: #919199;
      text-decoration: none;
    }
    .haveReadAndAgree{
      position: relative;
      top: (3vw / $w);
      height: (15vw / $w);
    }
    .highlighted{
      color: #2E2E33;
    }

  }
}
.dialog-outer {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: rgba(0,0,0,0.6);
  z-index: 999;
  .content {
    width: (305vw / $w);
    background: rgba(255,255,255,1);
    margin: (200vw / $w) auto 0;
    padding: (48vw/ $w) (20vw / $w) (20vw / $w);
    border-radius: (4vw / $w);
    font-family: PingFangSC-Regular,PingFang SC;
    position: relative;
    .text {
      color: #2E2E33;
      font-size: (15vw / $w);
      line-height: (26vw / $w);
      margin-bottom: (25vw / $w);
      // margin-top: (14vw / $w);
      text-align: center;
    }
    .text-two {
      color: #2E2E33;
      font-size: (15vw / $w);
      margin-bottom: (25vw / $w);
      margin-top: (-22vw / $w);
      text-align: center;
    }
    .dialog-btn {
      background: #FF142D;
      border-radius: (4vw / $w);
      width: (265vw / $w);
      height: (44vw / $w);
      line-height: (44vw / $w);
      font-size: (16vw / $w);
      color: #fff;
      text-align: center;
    }
    .dialog-title {
      font-size: (16vw / $w);
      color: #333333;
      line-height: (23vw / $w);
      text-align: center;
    }
    .check-img-btn {
      margin-top: (18vw / $w);
    }
    .img-code-outer {
      border: 1px solid rgba(237,237,237,1);
      background: rgba(250,250,250,1);
      width: (265vw / $w);
      height: (44vw / $w);
      line-height: (44vw / $w);
      border-radius: (2vw / $w);
      margin-top: (15vw / $w);
      .img-code {
        border: none;
        text-indent: (18vw / $w);
        float: left;
        width: (190vw / $w);
        height: (42vw / $w);
        border: 1px solid red;
        font-size: (16vw / $w);
      }
      .get-img-code {
        float: right;
        width: (72vw / $w);
        height: (42vw / $w);
      }
    }
    .tip-info {
      clear: both;
      height: (20vw / $w);
      margin-top: (15vw / $w);
      font-size: (14vw / $w);
      .code-info {
        float: left;
        color: #FF142D;
      }
      .img-info {
        float: right;
        cursor: pointer;
      }
    }
    .dialog-close {
      position: absolute;
      width: (16vw / $w);
      height: (16vw / $w);
      top: (16vw / $w);
      right: (16vw / $w);
    }
    .success-outer {
      .success-img {
        width: (40vw / $w);
        height: (40vw / $w);
        margin: 0 auto (15vw / $w) auto;
      }
    }
  }
  .content-code {
    margin-top: (140vw / $w);
  }
}
</style>
<style>
  body.modal-open {
    position: fixed;
    width: 100%;
  }
</style>
<script>
import Vue from 'vue';
import axios from 'axios';
import debounce from '../../../modules/js/privateServerLodash';
const bodyCls = 'modal-open';
const BASEURL = '';

export default Vue.extend({
  directives: {
    debounce
  },
  data() {
    return {
      showCode: false,
      phoneNumber: '',
      code: '',
      count: 60,
      finalPhone: '',
      finalCode: '',
      imgCode: '',
      codeSrc: '',
      timer: null,
      showAlreadyRegister: false,
      showPictureCode: false,
      showRegisterSuccess: false,
      scrollTop: 0,
      token: '',
      sessionId: '',
      userInfo: {},
      isRegister: false,
      buttonClicked: false,
      timeStamp: +new Date(),
      // 是否用户主动下载
      userDownload: false,
      readAndAgreeValue:false
    };
  },
  created(){
    this.getNavigtorInfo();
    this.getToken();
  },
  computed:{
    iphoneIs(){
      if (/iphone/gi.test(window.navigator.userAgent)) {
        return true
      }
      return false;
    }
  },
  methods: {
    // 获取ua信息
    getNavigtorInfo () {
      if (navigator) {
        this.userInfo.ua = navigator.userAgent;
        this.userInfo.platform = navigator.platform;
        if (/Linux/i.test(this.userInfo.platform)) {
          this.userInfo.platform = "Android";
        }
        this.userInfo.language = navigator.language;
        this.userInfo.longitude = ""; //经度
        this.userInfo.latitude = ""; //维度

        if (navigator.platform == "iPhone") {
          this.userInfo.osVersion = navigator.userAgent
            .split(";")[1]
            .split(" ")[4]
            ? navigator.userAgent
              .split(";")[1]
              .split(" ")[4]
              .split("_")
              .join(".")
            : "";
        } else {
          this.userInfo.osVersion = navigator.userAgent.split("Android")[1]
            ? navigator.userAgent.split("Android")[1].split(";")[0]
            : "";
          if (
            this.userInfo.osVersion &&
            this.userInfo.osVersion.length > 10
          ) {
            let osVersion = this.userInfo.osVersion.split(" ")[0];
            this.userInfo.osVersion =
              osVersion.indexOf("/") >= 0
                ? osVersion.split("/")[1]
                : osVersion;
          }
        }
      }
    },
    // 下载app flag标识是否是用户主动下载
    download(flag=false) {
      this.userDownload = flag;
      this.$emit("statistics", "点击", "立即下载");
      this.$emit("openHFQ");
    },
    // 弹层显示、隐藏
    handleClose(show) {
      if(!this[show]) {
        this.scrollTop = document.scrollingElement.scrollTop;
        document.body.classList.add(bodyCls);
        document.body.style.top = -this.scrollTop + 'px';
      }else{
        document.body.classList.remove(bodyCls);
        document.scrollingElement.scrollTop = this.scrollTop;
      }
      this[show] = !this[show];
    },
    getCodeToRegister(flag=true) {
      if(!this.readAndAgreeValue){
        this.$Alert.info({
          content: '请先勾选协议',
          duration: 0.9
        });
        return;
      }
      this.userDownload = false;
      // 获取验证码注册
      if(this.isValidPhone(this.phoneNumber)) {
        if(this.showCode && flag) {
          // 注册
          if(this.isValidCode(this.code)) {
            this.registerAction();
          }else{
            // 验证码校验失败
          }
        }else {
          // this.showCode = true;
          this.buttonClicked = true;
          this.count = 60;
          this.getCode();
        }
      }else {
        // 手机号校验失败
      }
    },
    // 校验手机号
    isValidPhone(phone) {
      if(!phone) {
        this.$Alert.info({
          content: '手机号码有误，请重新输入',
          duration: 0.9
        });
        return false;
      }else if (!/^1\d{10}$/.test(phone)) {
        this.$Alert.info({
          content: '手机号码有误，请重新输入',
          duration: 0.9
        });
        return false;
      }
      this.finalPhone = this.phoneNumber;
      return true;
    },
    // 校验验证码
    isValidCode(code) {
      if (!code || code.length !== 6) {
        this.$Alert.info({
          content: '验证码有误，请重新输入',
          duration: 0.9
        });
        return false;
      }
      this.finalCode = code;
      return true;
    },
    // 获取token & sessionId
    getToken() {
      axios.request({
        method: 'post',
        url: BASEURL + '/api/v1/web/get-token',
        headers: {
          'YX-source': "h5",
          'YX-Timestamp': this.timeStamp,
          'YX-VersionName': '5.9.0',
          'YX-Version': '590',
        },
      }).then(res => {
        if (res.data.code === 0) {
          this.token = res.data.data.token;
          this.sessionId = res.data.data.sessionId;
        }
      }).catch(err => {
        this.$Alert.info({
          content: err.message,
          duration: 1.5
        });
      });
    },
    // 获取验证码
    getCode(phrase) {
      const timer = () => {
        if(this.count !== 0) {
          clearTimeout(this.timer);
          this.count--;
          this.timer = setTimeout(timer, 1000);
        }
      }
      timer();
      axios.request({
        method: 'post',
        url: BASEURL + '/api/v2/web/send-verify-code',
        headers: {
          'YX-source': "h5",
          'YX-Timestamp': this.timeStamp,
          'YX-VersionName': '5.9.0',
          'YX-Version': '590',
          // 'YX-TOKEN': this.token,
          // 'YX-SESSIONID': this.sessionId,
          'YX-tokenType': 1,
          'Content-Type': 'application/json; charset=utf-8'
        },
        data: JSON.stringify({
          data: {
            type: 'html',
            mobile: this.finalPhone,
            phrase,
            composite: undefined,
          }
        })
      }).then(res => {
        const { code, data } = res.data;
        if (code === 0) {
          this.showPictureCode = false;
          if(data.need_captcha === 1) {
            this.showPictureDialog();
          }else {
            this.$Alert.info({
              content: '验证码已发送',
              duration: 1.5
            });
            this.showCode = true;
          }
        }else {
          if(code === 1019){
            this.getToken();
            this.$Alert.info({
              content: '获取验证码失败，请重试',
              duration: 1.5
            });
          }else if(code === 13041){
            this.$Alert.info({
              content: '验证码发送过于频繁，请1分钟后再试',
              duration: 1.5
            });
          }else if(code === 1020){
            this.$Alert.info({
              content: '图形验证码错误，请重试！',
              duration: 1.5
            });
            this.imgCode = '';
            this.getImgCode();
          }else if(code === 1308){
            this.showPictureCode = false;
            this.$nextTick(() => {
              // 老用户不显示验证码输入框
              this.showCode = false;
              this.buttonClicked = false;
              clearTimeout(this.timer);
              this.registerSuccessAction('showAlreadyRegister');
            })
          }else {
            this.$Alert.info({
              content: '获取验证码失败，请重试',
              duration: 1.5
            });
          }
        }
      }).catch(err => {
        this.$Alert.info({
          content: err.message,
          duration: 1.5
        });
      });
    },
    // 注册
    registerAction(phrase){
      axios.request({
        method: 'post',
        url: BASEURL + '/api/v2/web/register',
        headers: {
          'YX-source': 'h5',
          'YX-Timestamp': this.timeStamp,
          'YX-VersionName': '5.9.0',
          'YX-Version': '590',
          // 'YX-TOKEN': this.token,
          // 'YX-SESSIONID': this.sessionId,
          'YX-tokenType': 1,
          'Content-Type': 'application/json; charset=utf-8',
          'YX-Region': 'CN',
          'YX-Platform': this.userInfo.platform,
          'YX-Language': this.userInfo.language,
          'ad_ip' : '',
          'YX-Screen': window.screen ? window.screen.width + '*' + window.screen.height : '',
          'YX-Channel': '',
          'YX-OsVersion': this.userInfo.osVersion,
          'YX-NOPASSWORD': true,
        },
        data: JSON.stringify({
          data: {
            mobile: this.finalPhone,
            td_key: 'default',
            code: this.finalCode,
            pre_orderid: undefined,
            phrase,
            composite: undefined,
            utm_source: undefined,
            adid: undefined,
            creativeid: undefined,
            creativetype: undefined,
            clickid: undefined,
            deepType: '',
            deepParams: '',
          }
        })
      }).then(res => {
        const { code } = res.data;
        if (code === 0) {
          if(res.data.data.need_captcha === 1){
            this.showPictureDialog(true);
          }else {
            this.showPictureCode = false;
            this.registerSuccessAction('showRegisterSuccess');
          }
        }else {
          if(code === 1020){
            this.$Alert.info({
              content: '图形验证码错误，请重试！',
              duration: 1.5
            });
            this.imgCode = '';
            this.getImgCode();
          }else if(code === 1306 || code === 1307){
            this.showPictureCode = false;
            this.$Alert.info({
              content: '验证码有误，请重新输入',
              duration: 1.5
            });
          }else {
            this.showPictureCode = false;
            this.$Alert.info({
              content: `${res.data.desc}`,
              duration: 1.5
            });
          }
        }
      }).catch(err => {
        this.$Alert.info({
          content: err.message,
          duration: 1.5
        });
      });
    },
    // 注册成功，显示成功弹层-区分新用户和老用户
    registerSuccessAction(dialogName) {
      const ua = navigator.userAgent.toLowerCase();
      const platform = {
        // android终端或者uc浏览器
        android: ua.indexOf("android") > -1 || ua.indexOf("linux") > -1,
        androidVersion: 0,
        // 是否为iPhone或者QQHD浏览器
        iPhone: ua.indexOf("iphone") > -1,
        // 是否iPadip
        iPad: ua.indexOf("ipad") > -1,
        //ios version
        iosVersion: 0,
        //windows phone
        wPhone: ua.indexOf("windows phone") > -1,
        //是否在 微信 客户端内
        isWeixin: ua.indexOf("micromessenger") > -1,
        isVivo: ua.indexOf("vivo") > -1,
        mfAndroid:
          ua.indexOf("android") > -1 ||
          ua.indexOf("adr") > -1 ||
          ua.indexOf("linux") > -1,
        mfAldb: ua.indexOf("magicloan") > -1,
      };
      this[dialogName] = true;
      this.$nextTick(() => {
        // const timerSuccess = () => {
        //   if(this.downloadTime !== 0) {
        //     this.downloadTime--;
        //     setTimeout(timerSuccess, 1000)
        //   }else {
        //     this[dialogName] = false;
        //     if(!this.userDownload){
        //       // 安卓自动下载，IOS跳转至链接
        //       if (platform.iPhone || platform.iPad) {
        //         window.location.href = 'https://sj.qq.com/myapp/detail.htm?apkName=com.renrendai.haohuan'
        //       }else {
        //         this.download();
        //       }
        //     }
        //   }
        // }
        // timerSuccess();
      })
    },
    // 获取图形验证码
    getImgCode() {
      axios.request({
        method: 'post',
        url: BASEURL + '/api/v1/captcha/get-captcha-image',
        headers: {
          'YX-source': 'h5',
          'YX-Timestamp': this.timeStamp,
          'YX-VersionName': '5.9.0',
          'YX-Version': '590',
          'YX-TOKEN': this.token,
          'YX-tokenType': 1,
          'Content-Type': 'application/json; charset=utf-8'
        }
      }).then(res => {
        if (res.data.code === 0) {
          this.codeSrc = res.data.data.path;
        }else {
          this.$Alert.info({
            content: '获取图形验证码失败，请重试',
            duration: 1.5
          });
        }
      }).catch(err => {
        this.$Alert.info({
          content: err.message,
          duration: 1.5
        });
      });
    },
    // 校验图形验证码
    actualVerifyImgCode() {
      if(!this.imgCode) {
        this.$Alert.info({
          content: '请输入图形验证码！',
          duration: 1.5
        });
        return
      }
      if(!/^\d\d{4}\d$/.test(this.imgCode)) {
        this.$Alert.info({
          content: '图形验证码有误，请重填！',
          duration: 1.5
        });
        return
      }
      if(this.isRegister) {
        this.registerAction(this.imgCode);
      }else {
        this.getCode(this.imgCode);
      }
    },
    // 显示图形验证码层
    showPictureDialog(flag=false) {
      this.isRegister = flag;
      this.showPictureCode = true;
      this.imgCode = '';
      this.getImgCode();
    },
  },
  destroyed() {
    clearTimeout(this.timer);
    document.body.classList.remove(bodyCls);
  }
});
</script>
